// Generated by https://quicktype.io

export class ItemPaginate {
    current_page:   number;
    data:           Items[];
    first_page_url: string;
    from:           number;
    last_page:      number;
    last_page_url:  string;
    next_page_url:  null;
    path:           string;
    per_page:       number;
    prev_page_url:  null;
    to:             number;
    total:          number;
}

export class ItemPaginateMilestones {
    current_page:   number;
    data:           ItemMilestones[];
    first_page_url: string;
    from:           number;
    last_page:      number;
    last_page_url:  string;
    next_page_url:  null;
    path:           string;
    per_page:       number;
    prev_page_url:  null;
    to:             number;
    total:          number;
}

export class Items {
    id:                number;
    item_name:         string;
    short_description: string = '';
    description:       string = '';
    hq_image:          string;
    lq_image:          string;
    minimum_amount:    number;
    publish_date:      string;
    item_category:     number;
    item_target:       number;
    need_type:         number;
    is_active:         number;
    goal_amount:number;
    goal_qty:number;
    created_at:        string;
    updated_at:        string;
    motivation_code: number;
    show_item: string;
    view_order:number;
    sub_img1: string;
    sub_img2: string;
    sub_img3: string;
    sub_img4: string;
    sub_img5: string;
}


// Generated by https://quicktype.io

export class ItemMilestones {
    id:                number;
    item_id:           number;
    title:             string;
    milestone_date: string;
    description:       string;
    img1:              string;
    img2:              string;
    img3:              string;
    img4:              string;
    img5:              string;
    img6:              string;
    img7:              string;
    img8:              string;
    img9:              string;
    img10:             string;
    is_active:         number;
    added_by:          number;
    updated_by:        number;
    created_at:        string;
    updated_at:        string;
    item_name:         string;
    sent_notif: number;
}
